import DatePicker from 'vue2-datepicker'

export default {
  DatePicker
}



// WEBPACK FOOTER //
// ./src/app/tenant/access/resources/components.js